export const countriesTranslations = {
    en: {
        AF: {
            alpha3Code: 'AFG',
            name: 'Afghanistan',
            currencyName: 'Afghan afghani',
        },
        AX: {
            alpha3Code: 'ALA',
            name: 'Åland Islands',
            currencyName: 'Euro',
        },
        AL: {
            alpha3Code: 'ALB',
            name: 'Albania',
            currencyName: 'Albanian lek',
        },
        DZ: {
            alpha3Code: 'DZA',
            name: 'Algeria',
            currencyName: 'Algerian dinar',
        },
        AS: {
            alpha3Code: 'ASM',
            name: 'American Samoa',
            currencyName: 'US Dollar',
        },
        AD: {
            alpha3Code: 'AND',
            name: 'Andorra',
            currencyName: 'Euro',
        },
        AO: {
            alpha3Code: 'AGO',
            name: 'Angola',
            currencyName: 'Angolan kwanza',
        },
        AI: {
            alpha3Code: 'AIA',
            name: 'Anguilla',
            currencyName: 'East Caribbean dollar',
        },
        AQ: {
            alpha3Code: 'ATA',
            name: 'Antarctica',
            currencyName: 'Australian dollar',
        },
        AG: {
            alpha3Code: 'ATG',
            name: 'Antigua and Barbuda',
            currencyName: 'East Caribbean dollar',
        },
        AR: {
            alpha3Code: 'ARG',
            name: 'Argentina',
            currencyName: 'Argentine peso',
        },
        AM: {
            alpha3Code: 'ARM',
            name: 'Armenia',
            currencyName: 'Armenian dram',
        },
        AW: {
            alpha3Code: 'ABW',
            name: 'Aruba',
            currencyName: 'Aruban florin',
        },
        AU: {
            alpha3Code: 'AUS',
            name: 'Australia',
            currencyName: 'Australian dollar',
        },
        AT: {
            alpha3Code: 'AUT',
            name: 'Austria',
            currencyName: 'Euro',
        },
        AZ: {
            alpha3Code: 'AZE',
            name: 'Azerbaijan',
            currencyName: 'Azerbaijani manat',
        },
        BS: {
            alpha3Code: 'BHS',
            name: 'Bahamas',
            currencyName: 'Bahamian dollar',
        },
        BH: {
            alpha3Code: 'BHR',
            name: 'Bahrain',
            currencyName: 'Bahraini dinar',
        },
        BD: {
            alpha3Code: 'BGD',
            name: 'Bangladesh',
            currencyName: 'Bangladeshi taka',
        },
        BB: {
            alpha3Code: 'BRB',
            name: 'Barbados',
            currencyName: 'Barbadian dollar',
        },
        BY: {
            alpha3Code: 'BLR',
            name: 'Belarus',
            currencyName: 'New Belarusian ruble',
        },
        BE: {
            alpha3Code: 'BEL',
            name: 'Belgium',
            currencyName: 'Euro',
        },
        BZ: {
            alpha3Code: 'BLZ',
            name: 'Belize',
            currencyName: 'Belize dollar',
        },
        BJ: {
            alpha3Code: 'BEN',
            name: 'Benin',
            currencyName: 'West African CFA franc',
        },
        BM: {
            alpha3Code: 'BMU',
            name: 'Bermuda',
            currencyName: 'Bermudian dollar',
        },
        BT: {
            alpha3Code: 'BTN',
            name: 'Bhutan',
            currencyName: 'Bhutanese ngultrum',
        },
        BO: {
            alpha3Code: 'BOL',
            name: 'Bolivia',
            currencyName: 'Bolivian boliviano',
        },
        BQ: {
            alpha3Code: 'BES',
            name: 'Bonaire, Sint Eustatius and Saba',
            currencyName: 'US dollar',
        },
        BA: {
            alpha3Code: 'BAM',
            name: 'Bosnia and Herzegovina',
            currencyName: 'Bosnian Mark',
        },
        BW: {
            alpha3Code: 'BWA',
            name: 'Botswana',
            currencyName: 'Botswana pula',
        },
        BV: {
            alpha3Code: 'BVT',
            name: 'Bouvet Island',
            currencyName: 'Norwegian krone',
        },
        BR: {
            alpha3Code: 'BRA',
            name: 'Brazil',
            currencyName: 'Brazilian real',
        },
        IO: {
            alpha3Code: 'IOT',
            name: 'British Indian Ocean Territory',
            currencyName: 'US dollar',
        },
        UM: {
            alpha3Code: 'UMI',
            name: 'US Minor Outlying Islands',
            currencyName: 'US Dollar',
        },
        VG: {
            alpha3Code: 'VGB',
            name: 'Virgin Islands (British)',
            currencyName: '[D]',
        },
        VI: {
            alpha3Code: 'VIR',
            name: 'Virgin Islands (U.S.)',
            currencyName: 'US dollar',
        },
        BN: {
            alpha3Code: 'BRN',
            name: 'Brunei Darussalam',
            currencyName: 'Brunei dollar',
        },
        BG: {
            alpha3Code: 'BGR',
            name: 'Bulgaria',
            currencyName: 'Bulgarian lev',
        },
        BF: {
            alpha3Code: 'BFA',
            name: 'Burkina Faso',
            currencyName: 'West African CFA franc',
        },
        BI: {
            alpha3Code: 'BDI',
            name: 'Burundi',
            currencyName: 'Burundian franc',
        },
        KH: {
            alpha3Code: 'KHM',
            name: 'Cambodia',
            currencyName: 'Cambodian riel',
        },
        CM: {
            alpha3Code: 'CMR',
            name: 'Cameroon',
            currencyName: 'Central African CFA franc',
        },
        CA: {
            alpha3Code: 'CAN',
            name: 'Canada',
            currencyName: 'Canadian dollar',
        },
        CV: {
            alpha3Code: 'CPV',
            name: 'Cabo Verde',
            currencyName: 'Cape Verdean escudo',
        },
        KY: {
            alpha3Code: 'CYM',
            name: 'Cayman Islands',
            currencyName: 'Cayman Islands dollar',
        },
        CF: {
            alpha3Code: 'CAF',
            name: 'Central African Republic',
            currencyName: 'Central African CFA franc',
        },
        TD: {
            alpha3Code: 'TCD',
            name: 'Chad',
            currencyName: 'Central African CFA franc',
        },
        CL: {
            alpha3Code: 'CHL',
            name: 'Chile',
            currencyName: 'Chilean peso',
        },
        CN: {
            alpha3Code: 'CHN',
            name: 'China',
            currencyName: 'Chinese yuan',
        },
        CX: {
            alpha3Code: 'CXR',
            name: 'Christmas Island',
            currencyName: 'Australian dollar',
        },
        CC: {
            alpha3Code: 'CCK',
            name: 'Cocos Islands',
            currencyName: 'Australian dollar',
        },
        CO: {
            alpha3Code: 'COL',
            name: 'Colombia',
            currencyName: 'Colombian peso',
        },
        KM: {
            alpha3Code: 'COM',
            name: 'Comoros',
            currencyName: 'Comorian franc',
        },
        CG: {
            alpha3Code: 'COG',
            name: 'Congo',
            currencyName: 'Central African CFA franc',
        },
        CD: {
            alpha3Code: 'COD',
            name: 'Congo (DRC)',
            currencyName: 'Congolese franc',
        },
        CK: {
            alpha3Code: 'COK',
            name: 'Cook Islands',
            currencyName: 'New Zealand dollar',
        },
        CR: {
            alpha3Code: 'CRI',
            name: 'Costa Rica',
            currencyName: 'Costa Rican colón',
        },
        HR: {
            alpha3Code: 'HRV',
            name: 'Croatia',
            currencyName: 'Croatian kuna',
        },
        CU: {
            alpha3Code: 'CUB',
            name: 'Cuba',
            currencyName: 'Cuban convertible peso',
        },
        CW: {
            alpha3Code: 'CUW',
            name: 'Curaçao',
            currencyName: 'Netherlands Antillean guilder',
        },
        CY: {
            alpha3Code: 'CYP',
            name: 'Cyprus',
            currencyName: 'Euro',
        },
        CZ: {
            alpha3Code: 'CZE',
            name: 'Czech Republic',
            currencyName: 'Czech koruna',
        },
        DK: {
            alpha3Code: 'DNK',
            name: 'Denmark',
            currencyName: 'Danish krone',
        },
        DJ: {
            alpha3Code: 'DJI',
            name: 'Djibouti',
            currencyName: 'Djiboutian franc',
        },
        DM: {
            alpha3Code: 'DMA',
            name: 'Dominica',
            currencyName: 'East Caribbean dollar',
        },
        DO: {
            alpha3Code: 'DOM',
            name: 'Dominican Republic',
            currencyName: 'Dominican peso',
        },
        EC: {
            alpha3Code: 'ECU',
            name: 'Ecuador',
            currencyName: 'US dollar',
        },
        EG: {
            alpha3Code: 'EGY',
            name: 'Egypt',
            currencyName: 'Egyptian pound',
        },
        SV: {
            alpha3Code: 'SLV',
            name: 'El Salvador',
            currencyName: 'US dollar',
        },
        GQ: {
            alpha3Code: 'GNQ',
            name: 'Equatorial Guinea',
            currencyName: 'Central African CFA franc',
        },
        ER: {
            alpha3Code: 'ERI',
            name: 'Eritrea',
            currencyName: 'Eritrean nakfa',
        },
        EE: {
            alpha3Code: 'EST',
            name: 'Estonia',
            currencyName: 'Euro',
        },
        ET: {
            alpha3Code: 'ETH',
            name: 'Ethiopia',
            currencyName: 'Ethiopian birr',
        },
        FK: {
            alpha3Code: 'FLK',
            name: 'Falkland Islands',
            currencyName: 'Falkland Islands pound',
        },
        FO: {
            alpha3Code: 'FRO',
            name: 'Faroe Islands',
            currencyName: 'Danish krone',
        },
        FJ: {
            alpha3Code: 'FJI',
            name: 'Fiji',
            currencyName: 'Fijian dollar',
        },
        FI: {
            alpha3Code: 'FIN',
            name: 'Finland',
            currencyName: 'Euro',
        },
        FR: {
            alpha3Code: 'FRA',
            name: 'France',
            currencyName: 'Euro',
        },
        GF: {
            alpha3Code: 'GUF',
            name: 'French Guiana',
            currencyName: 'Euro',
        },
        PF: {
            alpha3Code: 'PYF',
            name: 'French Polynesia',
            currencyName: 'CFP franc',
        },
        TF: {
            alpha3Code: 'ATF',
            name: 'French Southern Territories',
            currencyName: 'Euro',
        },
        GA: {
            alpha3Code: 'GAB',
            name: 'Gabon',
            currencyName: 'Central African CFA franc',
        },
        GM: {
            alpha3Code: 'GMB',
            name: 'Gambia',
            currencyName: 'Gambian dalasi',
        },
        GE: {
            alpha3Code: 'GEO',
            name: 'Georgia',
            currencyName: 'Georgian Lari',
        },
        DE: {
            alpha3Code: 'DEU',
            name: 'Germany',
            currencyName: 'Euro',
        },
        GH: {
            alpha3Code: 'GHA',
            name: 'Ghana',
            currencyName: 'Ghanaian cedi',
        },
        GI: {
            alpha3Code: 'GIB',
            name: 'Gibraltar',
            currencyName: 'Gibraltar pound',
        },
        GR: {
            alpha3Code: 'GRC',
            name: 'Greece',
            currencyName: 'Euro',
        },
        GL: {
            alpha3Code: 'GRL',
            name: 'Greenland',
            currencyName: 'Danish krone',
        },
        GD: {
            alpha3Code: 'GRD',
            name: 'Grenada',
            currencyName: 'East Caribbean dollar',
        },
        GP: {
            alpha3Code: 'GLP',
            name: 'Guadeloupe',
            currencyName: 'Euro',
        },
        GU: {
            alpha3Code: 'GUM',
            name: 'Guam',
            currencyName: 'US dollar',
        },
        GT: {
            alpha3Code: 'GTM',
            name: 'Guatemala',
            currencyName: 'Guatemalan quetzal',
        },
        GG: {
            alpha3Code: 'GGY',
            name: 'Guernsey',
            currencyName: 'British pound',
        },
        GN: {
            alpha3Code: 'GIN',
            name: 'Guinea',
            currencyName: 'Guinean franc',
        },
        GW: {
            alpha3Code: 'GNB',
            name: 'Guinea-Bissau',
            currencyName: 'West African CFA franc',
        },
        GY: {
            alpha3Code: 'GUY',
            name: 'Guyana',
            currencyName: 'Guyanese dollar',
        },
        HT: {
            alpha3Code: 'HTI',
            name: 'Haiti',
            currencyName: 'Haitian gourde',
        },
        HM: {
            alpha3Code: 'HMD',
            name: 'Heard Island and McDonald Islands',
            currencyName: 'Australian dollar',
        },
        VA: {
            alpha3Code: 'VAT',
            name: 'Holy See',
            currencyName: 'Euro',
        },
        HN: {
            alpha3Code: 'HND',
            name: 'Honduras',
            currencyName: 'Honduran lempira',
        },
        HK: {
            alpha3Code: 'HKG',
            name: 'Hong Kong',
            currencyName: 'Hong Kong dollar',
        },
        HU: {
            alpha3Code: 'HUN',
            name: 'Hungary',
            currencyName: 'Hungarian forint',
        },
        IS: {
            alpha3Code: 'ISL',
            name: 'Iceland',
            currencyName: 'Icelandic króna',
        },
        IN: {
            alpha3Code: 'IND',
            name: 'India',
            currencyName: 'Indian rupee',
        },
        ID: {
            alpha3Code: 'IDN',
            name: 'Indonesia',
            currencyName: 'Indonesian rupiah',
        },
        CI: {
            alpha3Code: 'CIV',
            name: "Côte d'Ivoire",
            currencyName: 'West African CFA franc',
        },
        IR: {
            alpha3Code: 'IRN',
            name: 'Iran',
            currencyName: 'Iranian rial',
        },
        IQ: {
            alpha3Code: 'IRQ',
            name: 'Iraq',
            currencyName: 'Iraqi dinar',
        },
        IE: {
            alpha3Code: 'IRL',
            name: 'Ireland',
            currencyName: 'Euro',
        },
        IM: {
            alpha3Code: 'IMN',
            name: 'Isle of Man',
            currencyName: 'British pound',
        },
        IL: {
            alpha3Code: 'ISR',
            name: 'Israel',
            currencyName: 'Israeli new shekel',
        },
        IT: {
            alpha3Code: 'ITA',
            name: 'Italy',
            currencyName: 'Euro',
        },
        JM: {
            alpha3Code: 'JAM',
            name: 'Jamaica',
            currencyName: 'Jamaican dollar',
        },
        JP: {
            alpha3Code: 'JPN',
            name: 'Japan',
            currencyName: 'Japanese yen',
        },
        JE: {
            alpha3Code: 'JEY',
            name: 'Jersey',
            currencyName: 'British pound',
        },
        JO: {
            alpha3Code: 'JOR',
            name: 'Jordan',
            currencyName: 'Jordanian dinar',
        },
        KZ: {
            alpha3Code: 'KAZ',
            name: 'Kazakhstan',
            currencyName: 'Kazakhstani tenge',
        },
        KE: {
            alpha3Code: 'KEN',
            name: 'Kenya',
            currencyName: 'Kenyan shilling',
        },
        KI: {
            alpha3Code: 'KIR',
            name: 'Kiribati',
            currencyName: 'Australian dollar',
        },
        KW: {
            alpha3Code: 'KWT',
            name: 'Kuwait',
            currencyName: 'Kuwaiti dinar',
        },
        KG: {
            alpha3Code: 'KGZ',
            name: 'Kyrgyzstan',
            currencyName: 'Kyrgyzstani som',
        },
        LA: {
            alpha3Code: 'LAO',
            name: 'Lao',
            currencyName: 'Lao kip',
        },
        LV: {
            alpha3Code: 'LVA',
            name: 'Latvia',
            currencyName: 'Euro',
        },
        LB: {
            alpha3Code: 'LBN',
            name: 'Lebanon',
            currencyName: 'Lebanese pound',
        },
        LS: {
            alpha3Code: 'LSO',
            name: 'Lesotho',
            currencyName: 'Lesotho loti',
        },
        LR: {
            alpha3Code: 'LBR',
            name: 'Liberia',
            currencyName: 'Liberian dollar',
        },
        LY: {
            alpha3Code: 'LBY',
            name: 'Libya',
            currencyName: 'Libyan dinar',
        },
        LI: {
            alpha3Code: 'LIE',
            name: 'Liechtenstein',
            currencyName: 'Swiss franc',
        },
        LT: {
            alpha3Code: 'LTU',
            name: 'Lithuania',
            currencyName: 'Euro',
        },
        LU: {
            alpha3Code: 'LUX',
            name: 'Luxembourg',
            currencyName: 'Euro',
        },
        MO: {
            alpha3Code: 'MAC',
            name: 'Macao',
            currencyName: 'Macanese pataca',
        },
        MK: {
            alpha3Code: 'MKD',
            name: 'Macedonia',
            currencyName: 'Macedonian denar',
        },
        MG: {
            alpha3Code: 'MDG',
            name: 'Madagascar',
            currencyName: 'Malagasy ariary',
        },
        MW: {
            alpha3Code: 'MWI',
            name: 'Malawi',
            currencyName: 'Malawian kwacha',
        },
        MY: {
            alpha3Code: 'MYS',
            name: 'Malaysia',
            currencyName: 'Malaysian ringgit',
        },
        MV: {
            alpha3Code: 'MDV',
            name: 'Maldives',
            currencyName: 'Maldivian rufiyaa',
        },
        ML: {
            alpha3Code: 'MLI',
            name: 'Mali',
            currencyName: 'West African CFA franc',
        },
        MT: {
            alpha3Code: 'MLT',
            name: 'Malta',
            currencyName: 'Euro',
        },
        MH: {
            alpha3Code: 'MHL',
            name: 'Marshall Islands',
            currencyName: 'US dollar',
        },
        MQ: {
            alpha3Code: 'MTQ',
            name: 'Martinique',
            currencyName: 'Euro',
        },
        MR: {
            alpha3Code: 'MRT',
            name: 'Mauritania',
            currencyName: 'Mauritanian ouguiya',
        },
        MU: {
            alpha3Code: 'MUS',
            name: 'Mauritius',
            currencyName: 'Mauritian rupee',
        },
        YT: {
            alpha3Code: 'MYT',
            name: 'Mayotte',
            currencyName: 'Euro',
        },
        MX: {
            alpha3Code: 'MEX',
            name: 'Mexico',
            currencyName: 'Mexican peso',
        },
        FM: {
            alpha3Code: 'FSM',
            name: 'Micronesia',
            currencyName: '[D]',
        },
        MD: {
            alpha3Code: 'MDA',
            name: 'Moldova',
            currencyName: 'Moldovan leu',
        },
        MC: {
            alpha3Code: 'MCO',
            name: 'Monaco',
            currencyName: 'Euro',
        },
        MN: {
            alpha3Code: 'MNG',
            name: 'Mongolia',
            currencyName: 'Mongolian tögrög',
        },
        ME: {
            alpha3Code: 'MNE',
            name: 'Montenegro',
            currencyName: 'Euro',
        },
        MS: {
            alpha3Code: 'MSR',
            name: 'Montserrat',
            currencyName: 'East Caribbean dollar',
        },
        MA: {
            alpha3Code: 'MAR',
            name: 'Morocco',
            currencyName: 'Moroccan dirham',
        },
        MZ: {
            alpha3Code: 'MOZ',
            name: 'Mozambique',
            currencyName: 'Mozambican metical',
        },
        MM: {
            alpha3Code: 'MMR',
            name: 'Myanmar',
            currencyName: 'Burmese kyat',
        },
        NA: {
            alpha3Code: 'NAM',
            name: 'Namibia',
            currencyName: 'Namibian dollar',
        },
        NR: {
            alpha3Code: 'NRU',
            name: 'Nauru',
            currencyName: 'Australian dollar',
        },
        NP: {
            alpha3Code: 'NPL',
            name: 'Nepal',
            currencyName: 'Nepalese rupee',
        },
        NL: {
            alpha3Code: 'NLD',
            name: 'Netherlands',
            currencyName: 'Euro',
        },
        NC: {
            alpha3Code: 'NCL',
            name: 'New Caledonia',
            currencyName: 'CFP franc',
        },
        NZ: {
            alpha3Code: 'NZL',
            name: 'New Zealand',
            currencyName: 'New Zealand dollar',
        },
        NI: {
            alpha3Code: 'NIC',
            name: 'Nicaragua',
            currencyName: 'Nicaraguan córdoba',
        },
        NE: {
            alpha3Code: 'NER',
            name: 'Niger',
            currencyName: 'West African CFA franc',
        },
        NG: {
            alpha3Code: 'NGA',
            name: 'Nigeria',
            currencyName: 'Nigerian naira',
        },
        NU: {
            alpha3Code: 'NIU',
            name: 'Niue',
            currencyName: 'New Zealand dollar',
        },
        NF: {
            alpha3Code: 'NFK',
            name: 'Norfolk Island',
            currencyName: 'Australian dollar',
        },
        KP: {
            alpha3Code: 'PRK',
            name: 'North Korea',
            currencyName: 'North Korean won',
        },
        MP: {
            alpha3Code: 'MNP',
            name: 'Northern Mariana Islands',
            currencyName: 'US dollar',
        },
        NO: {
            alpha3Code: 'NOR',
            name: 'Norway',
            currencyName: 'Norwegian krone',
        },
        OM: {
            alpha3Code: 'OMN',
            name: 'Oman',
            currencyName: 'Omani rial',
        },
        PK: {
            alpha3Code: 'PAK',
            name: 'Pakistan',
            currencyName: 'Pakistani rupee',
        },
        PW: {
            alpha3Code: 'PLW',
            name: 'Palau',
            currencyName: '[E]',
        },
        PS: {
            alpha3Code: 'PSE',
            name: 'Palestine',
            currencyName: 'Israeli new sheqel',
        },
        PA: {
            alpha3Code: 'PAN',
            name: 'Panama',
            currencyName: 'Panamanian balboa',
        },
        PG: {
            alpha3Code: 'PNG',
            name: 'Papua New Guinea',
            currencyName: 'Papua New Guinean kina',
        },
        PY: {
            alpha3Code: 'PRY',
            name: 'Paraguay',
            currencyName: 'Paraguayan guaraní',
        },
        PE: {
            alpha3Code: 'PER',
            name: 'Peru',
            currencyName: 'Peruvian sol',
        },
        PH: {
            alpha3Code: 'PHL',
            name: 'Philippines',
            currencyName: 'Philippine peso',
        },
        PN: {
            alpha3Code: 'PCN',
            name: 'Pitcairn',
            currencyName: 'New Zealand dollar',
        },
        PL: {
            alpha3Code: 'POL',
            name: 'Poland',
            currencyName: 'Polish złoty',
        },
        PT: {
            alpha3Code: 'PRT',
            name: 'Portugal',
            currencyName: 'Euro',
        },
        PR: {
            alpha3Code: 'PRI',
            name: 'Puerto Rico',
            currencyName: 'US dollar',
        },
        QA: {
            alpha3Code: 'QAT',
            name: 'Qatar',
            currencyName: 'Qatari riyal',
        },
        XK: {
            alpha3Code: 'KOS',
            name: 'Republic of Kosovo',
            currencyName: 'Euro',
        },
        RE: {
            alpha3Code: 'REU',
            name: 'Réunion',
            currencyName: 'Euro',
        },
        RO: {
            alpha3Code: 'ROU',
            name: 'Romania',
            currencyName: 'Romanian leu',
        },
        RU: {
            alpha3Code: 'RUS',
            name: 'Russian Federation',
            currencyName: 'Russian ruble',
        },
        RW: {
            alpha3Code: 'RWA',
            name: 'Rwanda',
            currencyName: 'Rwandan franc',
        },
        BL: {
            alpha3Code: 'BLM',
            name: 'Saint Barthélemy',
            currencyName: 'Euro',
        },
        SH: {
            alpha3Code: 'SHN',
            name: 'Saint Helena, Ascension and Tristan da Cunha',
            currencyName: 'Saint Helena pound',
        },
        KN: {
            alpha3Code: 'KNA',
            name: 'Saint Kitts and Nevis',
            currencyName: 'East Caribbean dollar',
        },
        LC: {
            alpha3Code: 'LCA',
            name: 'Saint Lucia',
            currencyName: 'East Caribbean dollar',
        },
        MF: {
            alpha3Code: 'MAF',
            name: 'Saint Martin',
            currencyName: 'Euro',
        },
        PM: {
            alpha3Code: 'SPM',
            name: 'Saint Pierre and Miquelon',
            currencyName: 'Euro',
        },
        VC: {
            alpha3Code: 'VCT',
            name: 'Saint Vincent and the Grenadines',
            currencyName: 'East Caribbean dollar',
        },
        WS: {
            alpha3Code: 'WSM',
            name: 'Samoa',
            currencyName: 'Samoan tālā',
        },
        SM: {
            alpha3Code: 'SMR',
            name: 'San Marino',
            currencyName: 'Euro',
        },
        ST: {
            alpha3Code: 'STP',
            name: 'Sao Tome and Principe',
            currencyName: 'São Tomé and Príncipe dobra',
        },
        SA: {
            alpha3Code: 'SAU',
            name: 'Saudi Arabia',
            currencyName: 'Saudi riyal',
        },
        SN: {
            alpha3Code: 'SEN',
            name: 'Senegal',
            currencyName: 'West African CFA franc',
        },
        RS: {
            alpha3Code: 'SRB',
            name: 'Serbia',
            currencyName: 'Serbian dinar',
        },
        SC: {
            alpha3Code: 'SYC',
            name: 'Seychelles',
            currencyName: 'Seychellois rupee',
        },
        SL: {
            alpha3Code: 'SLE',
            name: 'Sierra Leone',
            currencyName: 'Sierra Leonean leone',
        },
        SG: {
            alpha3Code: 'SGP',
            name: 'Singapore',
            currencyName: 'Brunei dollar',
        },
        SX: {
            alpha3Code: 'SXM',
            name: 'Sint Maarten (NL)',
            currencyName: 'Netherlands Antillean guilder',
        },
        SK: {
            alpha3Code: 'SVK',
            name: 'Slovakia',
            currencyName: 'Euro',
        },
        SI: {
            alpha3Code: 'SVN',
            name: 'Slovenia',
            currencyName: 'Euro',
        },
        SB: {
            alpha3Code: 'SLB',
            name: 'Solomon Islands',
            currencyName: 'Solomon Islands dollar',
        },
        SO: {
            alpha3Code: 'SOM',
            name: 'Somalia',
            currencyName: 'Somali shilling',
        },
        ZA: {
            alpha3Code: 'ZAF',
            name: 'South Africa',
            currencyName: 'South African rand',
        },
        GS: {
            alpha3Code: 'SGS',
            name: 'South Georgia and the South Sandwich Islands',
            currencyName: 'British pound',
        },
        KR: {
            alpha3Code: 'KOR',
            name: 'South Korea',
            currencyName: 'South Korean won',
        },
        SS: {
            alpha3Code: 'SSD',
            name: 'South Sudan',
            currencyName: 'South Sudanese pound',
        },
        ES: {
            alpha3Code: 'ESP',
            name: 'Spain',
            currencyName: 'Euro',
        },
        LK: {
            alpha3Code: 'LKA',
            name: 'Sri Lanka',
            currencyName: 'Sri Lankan rupee',
        },
        SD: {
            alpha3Code: 'SDN',
            name: 'Sudan',
            currencyName: 'Sudanese pound',
        },
        SR: {
            alpha3Code: 'SUR',
            name: 'Suriname',
            currencyName: 'Surinamese dollar',
        },
        SJ: {
            alpha3Code: 'SJM',
            name: 'Svalbard and Jan Mayen',
            currencyName: 'Norwegian krone',
        },
        SZ: {
            alpha3Code: 'SWZ',
            name: 'Swaziland',
            currencyName: 'Swazi lilangeni',
        },
        SE: {
            alpha3Code: 'SWE',
            name: 'Sweden',
            currencyName: 'Swedish krona',
        },
        CH: {
            alpha3Code: 'CHE',
            name: 'Switzerland',
            currencyName: 'Swiss franc',
        },
        SY: {
            alpha3Code: 'SYR',
            name: 'Syria',
            currencyName: 'Syrian pound',
        },
        TW: {
            alpha3Code: 'TWN',
            name: 'Taiwan',
            currencyName: 'New Taiwan dollar',
        },
        TJ: {
            alpha3Code: 'TJK',
            name: 'Tajikistan',
            currencyName: 'Tajikistani somoni',
        },
        TZ: {
            alpha3Code: 'TZA',
            name: 'Tanzania',
            currencyName: 'Tanzanian shilling',
        },
        TH: {
            alpha3Code: 'THA',
            name: 'Thailand',
            currencyName: 'Thai baht',
        },
        TL: {
            alpha3Code: 'TLS',
            name: 'Timor-Leste',
            currencyName: 'US dollar',
        },
        TG: {
            alpha3Code: 'TGO',
            name: 'Togo',
            currencyName: 'West African CFA franc',
        },
        TK: {
            alpha3Code: 'TKL',
            name: 'Tokelau',
            currencyName: 'New Zealand dollar',
        },
        TO: {
            alpha3Code: 'TON',
            name: 'Tonga',
            currencyName: 'Tongan paʻanga',
        },
        TT: {
            alpha3Code: 'TTO',
            name: 'Trinidad and Tobago',
            currencyName: 'Trinidad and Tobago dollar',
        },
        TN: {
            alpha3Code: 'TUN',
            name: 'Tunisia',
            currencyName: 'Tunisian dinar',
        },
        TR: {
            alpha3Code: 'TUR',
            name: 'Turkey',
            currencyName: 'Turkish lira',
        },
        TM: {
            alpha3Code: 'TKM',
            name: 'Turkmenistan',
            currencyName: 'Turkmenistan manat',
        },
        TC: {
            alpha3Code: 'TCA',
            name: 'Turks and Caicos Islands',
            currencyName: 'US dollar',
        },
        TV: {
            alpha3Code: 'TUV',
            name: 'Tuvalu',
            currencyName: 'Australian dollar',
        },
        UG: {
            alpha3Code: 'UGA',
            name: 'Uganda',
            currencyName: 'Ugandan shilling',
        },
        UA: {
            alpha3Code: 'UKR',
            name: 'Ukraine',
            currencyName: 'Ukrainian hryvnia',
        },
        AE: {
            alpha3Code: 'ARE',
            name: 'United Arab Emirates',
            currencyName: 'United Arab Emirates dirham',
        },
        GB: {
            alpha3Code: 'GBR',
            name: 'United Kingdom',
            currencyName: 'British pound',
        },
        US: {
            alpha3Code: 'USA',
            name: 'USA',
            currencyName: 'US dollar',
        },
        UY: {
            alpha3Code: 'URY',
            name: 'Uruguay',
            currencyName: 'Uruguayan peso',
        },
        UZ: {
            alpha3Code: 'UZB',
            name: 'Uzbekistan',
            currencyName: "Uzbekistani so'm",
        },
        VU: {
            alpha3Code: 'VUT',
            name: 'Vanuatu',
            currencyName: 'Vanuatu vatu',
        },
        VE: {
            alpha3Code: 'VEN',
            name: 'Venezuela',
            currencyName: 'Venezuelan bolívar',
        },
        VN: {
            alpha3Code: 'VNM',
            name: 'Vietnam',
            currencyName: 'Vietnamese đồng',
        },
        WF: {
            alpha3Code: 'WLF',
            name: 'Wallis and Futuna',
            currencyName: 'CFP franc',
        },
        EH: {
            alpha3Code: 'ESH',
            name: 'Western Sahara',
            currencyName: 'Moroccan dirham',
        },
        YE: {
            alpha3Code: 'YEM',
            name: 'Yemen',
            currencyName: 'Yemeni rial',
        },
        ZM: {
            alpha3Code: 'ZMB',
            name: 'Zambia',
            currencyName: 'Zambian kwacha',
        },
        ZW: {
            alpha3Code: 'ZWE',
            name: 'Zimbabwe',
            currencyName: 'Botswana pula',
        },
    },
    ar: {
        AF: {
            alpha3Code: 'AFG',
            name: 'أفغانستان',
            currencyName: 'Afghan afghani',
        },
        AX: {
            alpha3Code: 'ALA',
            name: 'جزر أولان',
            currencyName: 'Euro',
        },
        AL: {
            alpha3Code: 'ALB',
            name: 'ألبانيا',
            currencyName: 'Albanian lek',
        },
        DZ: {
            alpha3Code: 'DZA',
            name: 'الجزائر',
            currencyName: 'Algerian dinar',
        },
        AS: {
            alpha3Code: 'ASM',
            name: 'ساموا الأمريكية',
            currencyName: 'US Dollar',
        },
        AD: {
            alpha3Code: 'AND',
            name: 'أندورا',
            currencyName: 'Euro',
        },
        AO: {
            alpha3Code: 'AGO',
            name: 'أنجولا',
            currencyName: 'Angolan kwanza',
        },
        AI: {
            alpha3Code: 'AIA',
            name: 'أنجويلا',
            currencyName: 'East Caribbean dollar',
        },
        AQ: {
            alpha3Code: 'ATA',
            name: 'القطب الجنوبي',
            currencyName: 'Australian dollar',
        },
        AG: {
            alpha3Code: 'ATG',
            name: 'أنتيجوا وبربودا',
            currencyName: 'East Caribbean dollar',
        },
        AR: {
            alpha3Code: 'ARG',
            name: 'الأرجنتين',
            currencyName: 'Argentine peso',
        },
        AM: {
            alpha3Code: 'ARM',
            name: 'أرمينيا',
            currencyName: 'Armenian dram',
        },
        AW: {
            alpha3Code: 'ABW',
            name: 'آروبا',
            currencyName: 'Aruban florin',
        },
        AU: {
            alpha3Code: 'AUS',
            name: 'أستراليا',
            currencyName: 'Australian dollar',
        },
        AT: {
            alpha3Code: 'AUT',
            name: 'النمسا',
            currencyName: 'Euro',
        },
        AZ: {
            alpha3Code: 'AZE',
            name: 'أذربيجان',
            currencyName: 'Azerbaijani manat',
        },
        BS: {
            alpha3Code: 'BHS',
            name: 'الباهاما',
            currencyName: 'Bahamian dollar',
        },
        BH: {
            alpha3Code: 'BHR',
            name: 'البحرين',
            currencyName: 'Bahraini dinar',
        },
        BD: {
            alpha3Code: 'BGD',
            name: 'بنجلاديش',
            currencyName: 'Bangladeshi taka',
        },
        BB: {
            alpha3Code: 'BRB',
            name: 'بربادوس',
            currencyName: 'Barbadian dollar',
        },
        BY: {
            alpha3Code: 'BLR',
            name: 'روسيا البيضاء',
            currencyName: 'New Belarusian ruble',
        },
        BE: {
            alpha3Code: 'BEL',
            name: 'بلجيكا',
            currencyName: 'Euro',
        },
        BZ: {
            alpha3Code: 'BLZ',
            name: 'بليز',
            currencyName: 'Belize dollar',
        },
        BJ: {
            alpha3Code: 'BEN',
            name: 'بنين',
            currencyName: 'West African CFA franc',
        },
        BM: {
            alpha3Code: 'BMU',
            name: 'برمودا',
            currencyName: 'Bermudian dollar',
        },
        BT: {
            alpha3Code: 'BTN',
            name: 'بوتان',
            currencyName: 'Bhutanese ngultrum',
        },
        BO: {
            alpha3Code: 'BOL',
            name: 'بوليفيا',
            currencyName: 'Bolivian boliviano',
        },
        BQ: {
            alpha3Code: 'BES',
            name: 'بونير',
            currencyName: 'US dollar',
        },
        BA: {
            alpha3Code: 'BAM',
            name: 'البوسنة والهرسك',
            currencyName: 'Bosnian Mark',
        },
        BW: {
            alpha3Code: 'BWA',
            name: 'بتسوانا',
            currencyName: 'Botswana pula',
        },
        BV: {
            alpha3Code: 'BVT',
            name: 'جزيرة بوفيه',
            currencyName: 'Norwegian krone',
        },
        BR: {
            alpha3Code: 'BRA',
            name: 'البرازيل',
            currencyName: 'Brazilian real',
        },
        IO: {
            alpha3Code: 'IOT',
            name: 'المحيط الهندي البريطاني',
            currencyName: 'US dollar',
        },
        UM: {
            alpha3Code: 'UMI',
            name: 'جزر الولايات المتحدة البعيدة الصغيرة',
            currencyName: 'US Dollar',
        },
        VG: {
            alpha3Code: 'VGB',
            name: 'جزر فرجين البريطانية',
            currencyName: '[D]',
        },
        VI: {
            alpha3Code: 'VIR',
            name: 'جزر فرجين الأمريكية',
            currencyName: 'US dollar',
        },
        BN: {
            alpha3Code: 'BRN',
            name: 'بروناي',
            currencyName: 'Brunei dollar',
        },
        BG: {
            alpha3Code: 'BGR',
            name: 'بلغاريا',
            currencyName: 'Bulgarian lev',
        },
        BF: {
            alpha3Code: 'BFA',
            name: 'بوركينا فاسو',
            currencyName: 'West African CFA franc',
        },
        BI: {
            alpha3Code: 'BDI',
            name: 'بوروندي',
            currencyName: 'Burundian franc',
        },
        KH: {
            alpha3Code: 'KHM',
            name: 'كمبوديا',
            currencyName: 'Cambodian riel',
        },
        CM: {
            alpha3Code: 'CMR',
            name: 'الكاميرون',
            currencyName: 'Central African CFA franc',
        },
        CA: {
            alpha3Code: 'CAN',
            name: 'كندا',
            currencyName: 'Canadian dollar',
        },
        CV: {
            alpha3Code: 'CPV',
            name: 'الرأس الأخضر',
            currencyName: 'Cape Verdean escudo',
        },
        KY: {
            alpha3Code: 'CYM',
            name: 'جزر الكايمن',
            currencyName: 'Cayman Islands dollar',
        },
        CF: {
            alpha3Code: 'CAF',
            name: 'جمهورية افريقيا الوسطى',
            currencyName: 'Central African CFA franc',
        },
        TD: {
            alpha3Code: 'TCD',
            name: 'تشاد',
            currencyName: 'Central African CFA franc',
        },
        CL: {
            alpha3Code: 'CHL',
            name: 'شيلي',
            currencyName: 'Chilean peso',
        },
        CN: {
            alpha3Code: 'CHN',
            name: 'الصين',
            currencyName: 'Chinese yuan',
        },
        CX: {
            alpha3Code: 'CXR',
            name: 'جزيرة الكريسماس',
            currencyName: 'Australian dollar',
        },
        CC: {
            alpha3Code: 'CCK',
            name: 'جزر كوكوس',
            currencyName: 'Australian dollar',
        },
        CO: {
            alpha3Code: 'COL',
            name: 'كولومبيا',
            currencyName: 'Colombian peso',
        },
        KM: {
            alpha3Code: 'COM',
            name: 'جزر القمر',
            currencyName: 'Comorian franc',
        },
        CG: {
            alpha3Code: 'COG',
            name: 'الكونغو - برازافيل',
            currencyName: 'Central African CFA franc',
        },
        CD: {
            alpha3Code: 'COD',
            name: 'جمهورية الكونغو الديمقراطية',
            currencyName: 'Congolese franc',
        },
        CK: {
            alpha3Code: 'COK',
            name: 'جزر كوك',
            currencyName: 'New Zealand dollar',
        },
        CR: {
            alpha3Code: 'CRI',
            name: 'كوستاريكا',
            currencyName: 'Costa Rican colón',
        },
        HR: {
            alpha3Code: 'HRV',
            name: 'كرواتيا',
            currencyName: 'Croatian kuna',
        },
        CU: {
            alpha3Code: 'CUB',
            name: 'كوبا',
            currencyName: 'Cuban convertible peso',
        },
        CW: {
            alpha3Code: 'CUW',
            name: 'كوراساو',
            currencyName: 'Netherlands Antillean guilder',
        },
        CY: {
            alpha3Code: 'CYP',
            name: 'قبرص',
            currencyName: 'Euro',
        },
        CZ: {
            alpha3Code: 'CZE',
            name: 'جمهورية التشيك',
            currencyName: 'Czech koruna',
        },
        DK: {
            alpha3Code: 'DNK',
            name: 'الدانمرك',
            currencyName: 'Danish krone',
        },
        DJ: {
            alpha3Code: 'DJI',
            name: 'جيبوتي',
            currencyName: 'Djiboutian franc',
        },
        DM: {
            alpha3Code: 'DMA',
            name: 'دومينيكا',
            currencyName: 'East Caribbean dollar',
        },
        DO: {
            alpha3Code: 'DOM',
            name: 'جمهورية الدومينيك',
            currencyName: 'Dominican peso',
        },
        EC: {
            alpha3Code: 'ECU',
            name: 'الاكوادور',
            currencyName: 'US dollar',
        },
        EG: {
            alpha3Code: 'EGY',
            name: 'مصر',
            currencyName: 'Egyptian pound',
        },
        SV: {
            alpha3Code: 'SLV',
            name: 'السلفادور',
            currencyName: 'US dollar',
        },
        GQ: {
            alpha3Code: 'GNQ',
            name: 'غينيا الاستوائية',
            currencyName: 'Central African CFA franc',
        },
        ER: {
            alpha3Code: 'ERI',
            name: 'اريتريا',
            currencyName: 'Eritrean nakfa',
        },
        EE: {
            alpha3Code: 'EST',
            name: 'استونيا',
            currencyName: 'Euro',
        },
        ET: {
            alpha3Code: 'ETH',
            name: 'اثيوبيا',
            currencyName: 'Ethiopian birr',
        },
        FK: {
            alpha3Code: 'FLK',
            name: 'جزر فوكلاند',
            currencyName: 'Falkland Islands pound',
        },
        FO: {
            alpha3Code: 'FRO',
            name: 'جزر فارو',
            currencyName: 'Danish krone',
        },
        FJ: {
            alpha3Code: 'FJI',
            name: 'فيجي',
            currencyName: 'Fijian dollar',
        },
        FI: {
            alpha3Code: 'FIN',
            name: 'فنلندا',
            currencyName: 'Euro',
        },
        FR: {
            alpha3Code: 'FRA',
            name: 'فرنسا',
            currencyName: 'Euro',
        },
        GF: {
            alpha3Code: 'GUF',
            name: 'غويانا',
            currencyName: 'Euro',
        },
        PF: {
            alpha3Code: 'PYF',
            name: 'بولينيزيا الفرنسية',
            currencyName: 'CFP franc',
        },
        TF: {
            alpha3Code: 'ATF',
            name: 'المقاطعات الجنوبية الفرنسية',
            currencyName: 'Euro',
        },
        GA: {
            alpha3Code: 'GAB',
            name: 'الجابون',
            currencyName: 'Central African CFA franc',
        },
        GM: {
            alpha3Code: 'GMB',
            name: 'غامبيا',
            currencyName: 'Gambian dalasi',
        },
        GE: {
            alpha3Code: 'GEO',
            name: 'جورجيا',
            currencyName: 'Georgian Lari',
        },
        DE: {
            alpha3Code: 'DEU',
            name: 'ألمانيا',
            currencyName: 'Euro',
        },
        GH: {
            alpha3Code: 'GHA',
            name: 'غانا',
            currencyName: 'Ghanaian cedi',
        },
        GI: {
            alpha3Code: 'GIB',
            name: 'جبل طارق',
            currencyName: 'Gibraltar pound',
        },
        GR: {
            alpha3Code: 'GRC',
            name: 'اليونان',
            currencyName: 'Euro',
        },
        GL: {
            alpha3Code: 'GRL',
            name: 'جرينلاند',
            currencyName: 'Danish krone',
        },
        GD: {
            alpha3Code: 'GRD',
            name: 'جرينادا',
            currencyName: 'East Caribbean dollar',
        },
        GP: {
            alpha3Code: 'GLP',
            name: 'جوادلوب',
            currencyName: 'Euro',
        },
        GU: {
            alpha3Code: 'GUM',
            name: 'جوام',
            currencyName: 'US dollar',
        },
        GT: {
            alpha3Code: 'GTM',
            name: 'جواتيمالا',
            currencyName: 'Guatemalan quetzal',
        },
        GG: {
            alpha3Code: 'GGY',
            name: 'غيرنزي',
            currencyName: 'British pound',
        },
        GN: {
            alpha3Code: 'GIN',
            name: 'غينيا',
            currencyName: 'Guinean franc',
        },
        GW: {
            alpha3Code: 'GNB',
            name: 'غينيا بيساو',
            currencyName: 'West African CFA franc',
        },
        GY: {
            alpha3Code: 'GUY',
            name: 'غيانا',
            currencyName: 'Guyanese dollar',
        },
        HT: {
            alpha3Code: 'HTI',
            name: 'هايتي',
            currencyName: 'Haitian gourde',
        },
        HM: {
            alpha3Code: 'HMD',
            name: 'جزيرة هيرد وماكدونالد',
            currencyName: 'Australian dollar',
        },
        VA: {
            alpha3Code: 'VAT',
            name: 'الفاتيكان',
            currencyName: 'Euro',
        },
        HN: {
            alpha3Code: 'HND',
            name: 'هندوراس',
            currencyName: 'Honduran lempira',
        },
        HK: {
            alpha3Code: 'HKG',
            name: 'هونج كونج الصينية',
            currencyName: 'Hong Kong dollar',
        },
        HU: {
            alpha3Code: 'HUN',
            name: 'المجر',
            currencyName: 'Hungarian forint',
        },
        IS: {
            alpha3Code: 'ISL',
            name: 'أيسلندا',
            currencyName: 'Icelandic króna',
        },
        IN: {
            alpha3Code: 'IND',
            name: 'الهند',
            currencyName: 'Indian rupee',
        },
        ID: {
            alpha3Code: 'IDN',
            name: 'اندونيسيا',
            currencyName: 'Indonesian rupiah',
        },
        CI: {
            alpha3Code: 'CIV',
            name: 'ساحل العاج',
            currencyName: 'West African CFA franc',
        },
        IR: {
            alpha3Code: 'IRN',
            name: 'ايران',
            currencyName: 'Iranian rial',
        },
        IQ: {
            alpha3Code: 'IRQ',
            name: 'العراق',
            currencyName: 'Iraqi dinar',
        },
        IE: {
            alpha3Code: 'IRL',
            name: 'أيرلندا',
            currencyName: 'Euro',
        },
        IM: {
            alpha3Code: 'IMN',
            name: 'جزيرة مان',
            currencyName: 'British pound',
        },
        IL: {
            alpha3Code: 'ISR',
            name: 'اسرائيل',
            currencyName: 'Israeli new shekel',
        },
        IT: {
            alpha3Code: 'ITA',
            name: 'ايطاليا',
            currencyName: 'Euro',
        },
        JM: {
            alpha3Code: 'JAM',
            name: 'جامايكا',
            currencyName: 'Jamaican dollar',
        },
        JP: {
            alpha3Code: 'JPN',
            name: 'اليابان',
            currencyName: 'Japanese yen',
        },
        JE: {
            alpha3Code: 'JEY',
            name: 'جيرسي',
            currencyName: 'British pound',
        },
        JO: {
            alpha3Code: 'JOR',
            name: 'الأردن',
            currencyName: 'Jordanian dinar',
        },
        KZ: {
            alpha3Code: 'KAZ',
            name: 'كازاخستان',
            currencyName: 'Kazakhstani tenge',
        },
        KE: {
            alpha3Code: 'KEN',
            name: 'كينيا',
            currencyName: 'Kenyan shilling',
        },
        KI: {
            alpha3Code: 'KIR',
            name: 'كيريباتي',
            currencyName: 'Australian dollar',
        },
        KW: {
            alpha3Code: 'KWT',
            name: 'الكويت',
            currencyName: 'Kuwaiti dinar',
        },
        KG: {
            alpha3Code: 'KGZ',
            name: 'قرغيزستان',
            currencyName: 'Kyrgyzstani som',
        },
        LA: {
            alpha3Code: 'LAO',
            name: 'لاوس',
            currencyName: 'Lao kip',
        },
        LV: {
            alpha3Code: 'LVA',
            name: 'لاتفيا',
            currencyName: 'Euro',
        },
        LB: {
            alpha3Code: 'LBN',
            name: 'لبنان',
            currencyName: 'Lebanese pound',
        },
        LS: {
            alpha3Code: 'LSO',
            name: 'ليسوتو',
            currencyName: 'Lesotho loti',
        },
        LR: {
            alpha3Code: 'LBR',
            name: 'ليبيريا',
            currencyName: 'Liberian dollar',
        },
        LY: {
            alpha3Code: 'LBY',
            name: 'ليبيا',
            currencyName: 'Libyan dinar',
        },
        LI: {
            alpha3Code: 'LIE',
            name: 'ليختنشتاين',
            currencyName: 'Swiss franc',
        },
        LT: {
            alpha3Code: 'LTU',
            name: 'ليتوانيا',
            currencyName: 'Euro',
        },
        LU: {
            alpha3Code: 'LUX',
            name: 'لوكسمبورج',
            currencyName: 'Euro',
        },
        MO: {
            alpha3Code: 'MAC',
            name: 'ماكاو الصينية',
            currencyName: 'Macanese pataca',
        },
        MK: {
            alpha3Code: 'MKD',
            name: 'مقدونيا',
            currencyName: 'Macedonian denar',
        },
        MG: {
            alpha3Code: 'MDG',
            name: 'مدغشقر',
            currencyName: 'Malagasy ariary',
        },
        MW: {
            alpha3Code: 'MWI',
            name: 'ملاوي',
            currencyName: 'Malawian kwacha',
        },
        MY: {
            alpha3Code: 'MYS',
            name: 'ماليزيا',
            currencyName: 'Malaysian ringgit',
        },
        MV: {
            alpha3Code: 'MDV',
            name: 'جزر الملديف',
            currencyName: 'Maldivian rufiyaa',
        },
        ML: {
            alpha3Code: 'MLI',
            name: 'مالي',
            currencyName: 'West African CFA franc',
        },
        MT: {
            alpha3Code: 'MLT',
            name: 'مالطا',
            currencyName: 'Euro',
        },
        MH: {
            alpha3Code: 'MHL',
            name: 'جزر المارشال',
            currencyName: 'US dollar',
        },
        MQ: {
            alpha3Code: 'MTQ',
            name: 'مارتينيك',
            currencyName: 'Euro',
        },
        MR: {
            alpha3Code: 'MRT',
            name: 'موريتانيا',
            currencyName: 'Mauritanian ouguiya',
        },
        MU: {
            alpha3Code: 'MUS',
            name: 'موريشيوس',
            currencyName: 'Mauritian rupee',
        },
        YT: {
            alpha3Code: 'MYT',
            name: 'مايوت',
            currencyName: 'Euro',
        },
        MX: {
            alpha3Code: 'MEX',
            name: 'المكسيك',
            currencyName: 'Mexican peso',
        },
        FM: {
            alpha3Code: 'FSM',
            name: 'ميكرونيزيا',
            currencyName: '[D]',
        },
        MD: {
            alpha3Code: 'MDA',
            name: 'مولدافيا',
            currencyName: 'Moldovan leu',
        },
        MC: {
            alpha3Code: 'MCO',
            name: 'موناكو',
            currencyName: 'Euro',
        },
        MN: {
            alpha3Code: 'MNG',
            name: 'منغوليا',
            currencyName: 'Mongolian tögrög',
        },
        ME: {
            alpha3Code: 'MNE',
            name: 'الجبل الأسود',
            currencyName: 'Euro',
        },
        MS: {
            alpha3Code: 'MSR',
            name: 'مونتسرات',
            currencyName: 'East Caribbean dollar',
        },
        MA: {
            alpha3Code: 'MAR',
            name: 'المغرب',
            currencyName: 'Moroccan dirham',
        },
        MZ: {
            alpha3Code: 'MOZ',
            name: 'موزمبيق',
            currencyName: 'Mozambican metical',
        },
        MM: {
            alpha3Code: 'MMR',
            name: 'ميانمار',
            currencyName: 'Burmese kyat',
        },
        NA: {
            alpha3Code: 'NAM',
            name: 'ناميبيا',
            currencyName: 'Namibian dollar',
        },
        NR: {
            alpha3Code: 'NRU',
            name: 'نورو',
            currencyName: 'Australian dollar',
        },
        NP: {
            alpha3Code: 'NPL',
            name: 'نيبال',
            currencyName: 'Nepalese rupee',
        },
        NL: {
            alpha3Code: 'NLD',
            name: 'هولندا',
            currencyName: 'Euro',
        },
        NC: {
            alpha3Code: 'NCL',
            name: 'كاليدونيا الجديدة',
            currencyName: 'CFP franc',
        },
        NZ: {
            alpha3Code: 'NZL',
            name: 'نيوزيلاندا',
            currencyName: 'New Zealand dollar',
        },
        NI: {
            alpha3Code: 'NIC',
            name: 'نيكاراجوا',
            currencyName: 'Nicaraguan córdoba',
        },
        NE: {
            alpha3Code: 'NER',
            name: 'النيجر',
            currencyName: 'West African CFA franc',
        },
        NG: {
            alpha3Code: 'NGA',
            name: 'نيجيريا',
            currencyName: 'Nigerian naira',
        },
        NU: {
            alpha3Code: 'NIU',
            name: 'نيوي',
            currencyName: 'New Zealand dollar',
        },
        NF: {
            alpha3Code: 'NFK',
            name: 'جزيرة نورفوك',
            currencyName: 'Australian dollar',
        },
        KP: {
            alpha3Code: 'PRK',
            name: 'كوريا الشمالية',
            currencyName: 'North Korean won',
        },
        MP: {
            alpha3Code: 'MNP',
            name: 'جزر ماريانا الشمالية',
            currencyName: 'US dollar',
        },
        NO: {
            alpha3Code: 'NOR',
            name: 'النرويج',
            currencyName: 'Norwegian krone',
        },
        OM: {
            alpha3Code: 'OMN',
            name: 'عمان',
            currencyName: 'Omani rial',
        },
        PK: {
            alpha3Code: 'PAK',
            name: 'باكستان',
            currencyName: 'Pakistani rupee',
        },
        PW: {
            alpha3Code: 'PLW',
            name: 'بالاو',
            currencyName: '[E]',
        },
        PS: {
            alpha3Code: 'PSE',
            name: 'فلسطين',
            currencyName: 'Israeli new sheqel',
        },
        PA: {
            alpha3Code: 'PAN',
            name: 'بنما',
            currencyName: 'Panamanian balboa',
        },
        PG: {
            alpha3Code: 'PNG',
            name: 'بابوا غينيا الجديدة',
            currencyName: 'Papua New Guinean kina',
        },
        PY: {
            alpha3Code: 'PRY',
            name: 'باراجواي',
            currencyName: 'Paraguayan guaraní',
        },
        PE: {
            alpha3Code: 'PER',
            name: 'بيرو',
            currencyName: 'Peruvian sol',
        },
        PH: {
            alpha3Code: 'PHL',
            name: 'الفيلبين',
            currencyName: 'Philippine peso',
        },
        PN: {
            alpha3Code: 'PCN',
            name: 'بتكايرن',
            currencyName: 'New Zealand dollar',
        },
        PL: {
            alpha3Code: 'POL',
            name: 'بولندا',
            currencyName: 'Polish złoty',
        },
        PT: {
            alpha3Code: 'PRT',
            name: 'البرتغال',
            currencyName: 'Euro',
        },
        PR: {
            alpha3Code: 'PRI',
            name: 'بورتوريكو',
            currencyName: 'US dollar',
        },
        QA: {
            alpha3Code: 'QAT',
            name: 'قطر',
            currencyName: 'Qatari riyal',
        },
        XK: {
            alpha3Code: 'KOS',
            name: 'كوسوفو',
            currencyName: 'Euro',
        },
        RE: {
            alpha3Code: 'REU',
            name: 'روينيون',
            currencyName: 'Euro',
        },
        RO: {
            alpha3Code: 'ROU',
            name: 'رومانيا',
            currencyName: 'Romanian leu',
        },
        RU: {
            alpha3Code: 'RUS',
            name: 'روسيا',
            currencyName: 'Russian ruble',
        },
        RW: {
            alpha3Code: 'RWA',
            name: 'رواندا',
            currencyName: 'Rwandan franc',
        },
        BL: {
            alpha3Code: 'BLM',
            name: 'سان بارتيلمي',
            currencyName: 'Euro',
        },
        SH: {
            alpha3Code: 'SHN',
            name: 'سانت هيلنا',
            currencyName: 'Saint Helena pound',
        },
        KN: {
            alpha3Code: 'KNA',
            name: 'سانت كيتس ونيفيس',
            currencyName: 'East Caribbean dollar',
        },
        LC: {
            alpha3Code: 'LCA',
            name: 'سانت لوسيا',
            currencyName: 'East Caribbean dollar',
        },
        MF: {
            alpha3Code: 'MAF',
            name: 'سانت مارتين',
            currencyName: 'Euro',
        },
        PM: {
            alpha3Code: 'SPM',
            name: 'سانت بيير وميكولون',
            currencyName: 'Euro',
        },
        VC: {
            alpha3Code: 'VCT',
            name: 'سانت فنسنت وغرنادين',
            currencyName: 'East Caribbean dollar',
        },
        WS: {
            alpha3Code: 'WSM',
            name: 'ساموا',
            currencyName: 'Samoan tālā',
        },
        SM: {
            alpha3Code: 'SMR',
            name: 'سان مارينو',
            currencyName: 'Euro',
        },
        ST: {
            alpha3Code: 'STP',
            name: 'ساو تومي وبرينسيبي',
            currencyName: 'São Tomé and Príncipe dobra',
        },
        SA: {
            alpha3Code: 'SAU',
            name: 'المملكة العربية السعودية',
            currencyName: 'Saudi riyal',
        },
        SN: {
            alpha3Code: 'SEN',
            name: 'السنغال',
            currencyName: 'West African CFA franc',
        },
        RS: {
            alpha3Code: 'SRB',
            name: 'صربيا',
            currencyName: 'Serbian dinar',
        },
        SC: {
            alpha3Code: 'SYC',
            name: 'سيشل',
            currencyName: 'Seychellois rupee',
        },
        SL: {
            alpha3Code: 'SLE',
            name: 'سيراليون',
            currencyName: 'Sierra Leonean leone',
        },
        SG: {
            alpha3Code: 'SGP',
            name: 'سنغافورة',
            currencyName: 'Brunei dollar',
        },
        SX: {
            alpha3Code: 'SXM',
            name: 'سينت مارتن',
            currencyName: 'Netherlands Antillean guilder',
        },
        SK: {
            alpha3Code: 'SVK',
            name: 'سلوفاكيا',
            currencyName: 'Euro',
        },
        SI: {
            alpha3Code: 'SVN',
            name: 'سلوفينيا',
            currencyName: 'Euro',
        },
        SB: {
            alpha3Code: 'SLB',
            name: 'جزر سليمان',
            currencyName: 'Solomon Islands dollar',
        },
        SO: {
            alpha3Code: 'SOM',
            name: 'الصومال',
            currencyName: 'Somali shilling',
        },
        ZA: {
            alpha3Code: 'ZAF',
            name: 'جمهورية جنوب افريقيا',
            currencyName: 'South African rand',
        },
        GS: {
            alpha3Code: 'SGS',
            name: 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
            currencyName: 'British pound',
        },
        KR: {
            alpha3Code: 'KOR',
            name: 'كوريا الجنوبية',
            currencyName: 'South Korean won',
        },
        SS: {
            alpha3Code: 'SSD',
            name: 'جنوب السودان',
            currencyName: 'South Sudanese pound',
        },
        ES: {
            alpha3Code: 'ESP',
            name: 'أسبانيا',
            currencyName: 'Euro',
        },
        LK: {
            alpha3Code: 'LKA',
            name: 'سريلانكا',
            currencyName: 'Sri Lankan rupee',
        },
        SD: {
            alpha3Code: 'SDN',
            name: 'السودان',
            currencyName: 'Sudanese pound',
        },
        SR: {
            alpha3Code: 'SUR',
            name: 'سورينام',
            currencyName: 'Surinamese dollar',
        },
        SJ: {
            alpha3Code: 'SJM',
            name: 'سفالبارد وجان مايان',
            currencyName: 'Norwegian krone',
        },
        SZ: {
            alpha3Code: 'SWZ',
            name: 'سوازيلاند',
            currencyName: 'Swazi lilangeni',
        },
        SE: {
            alpha3Code: 'SWE',
            name: 'السويد',
            currencyName: 'Swedish krona',
        },
        CH: {
            alpha3Code: 'CHE',
            name: 'سويسرا',
            currencyName: 'Swiss franc',
        },
        SY: {
            alpha3Code: 'SYR',
            name: 'سوريا',
            currencyName: 'Syrian pound',
        },
        TW: {
            alpha3Code: 'TWN',
            name: 'تايوان',
            currencyName: 'New Taiwan dollar',
        },
        TJ: {
            alpha3Code: 'TJK',
            name: 'طاجكستان',
            currencyName: 'Tajikistani somoni',
        },
        TZ: {
            alpha3Code: 'TZA',
            name: 'تانزانيا',
            currencyName: 'Tanzanian shilling',
        },
        TH: {
            alpha3Code: 'THA',
            name: 'تايلند',
            currencyName: 'Thai baht',
        },
        TL: {
            alpha3Code: 'TLS',
            name: 'تيمور الشرقية',
            currencyName: 'US dollar',
        },
        TG: {
            alpha3Code: 'TGO',
            name: 'توجو',
            currencyName: 'West African CFA franc',
        },
        TK: {
            alpha3Code: 'TKL',
            name: 'توكيلو',
            currencyName: 'New Zealand dollar',
        },
        TO: {
            alpha3Code: 'TON',
            name: 'تونجا',
            currencyName: 'Tongan paʻanga',
        },
        TT: {
            alpha3Code: 'TTO',
            name: 'ترينيداد وتوباغو',
            currencyName: 'Trinidad and Tobago dollar',
        },
        TN: {
            alpha3Code: 'TUN',
            name: 'تونس',
            currencyName: 'Tunisian dinar',
        },
        TR: {
            alpha3Code: 'TUR',
            name: 'تركيا',
            currencyName: 'Turkish lira',
        },
        TM: {
            alpha3Code: 'TKM',
            name: 'تركمانستان',
            currencyName: 'Turkmenistan manat',
        },
        TC: {
            alpha3Code: 'TCA',
            name: 'جزر الترك وجايكوس',
            currencyName: 'US dollar',
        },
        TV: {
            alpha3Code: 'TUV',
            name: 'توفالو',
            currencyName: 'Australian dollar',
        },
        UG: {
            alpha3Code: 'UGA',
            name: 'أوغندا',
            currencyName: 'Ugandan shilling',
        },
        UA: {
            alpha3Code: 'UKR',
            name: 'أوكرانيا',
            currencyName: 'Ukrainian hryvnia',
        },
        AE: {
            alpha3Code: 'ARE',
            name: 'الامارات العربية المتحدة',
            currencyName: 'United Arab Emirates dirham',
        },
        GB: {
            alpha3Code: 'GBR',
            name: 'المملكة المتحدة',
            currencyName: 'British pound',
        },
        US: {
            alpha3Code: 'USA',
            name: 'الولايات المتحدة الأمريكية',
            currencyName: 'US dollar',
        },
        UY: {
            alpha3Code: 'URY',
            name: 'أورجواي',
            currencyName: 'Uruguayan peso',
        },
        UZ: {
            alpha3Code: 'UZB',
            name: 'أوزبكستان',
            currencyName: "Uzbekistani so'm",
        },
        VU: {
            alpha3Code: 'VUT',
            name: 'فانواتو',
            currencyName: 'Vanuatu vatu',
        },
        VE: {
            alpha3Code: 'VEN',
            name: 'فنزويلا',
            currencyName: 'Venezuelan bolívar',
        },
        VN: {
            alpha3Code: 'VNM',
            name: 'فيتنام',
            currencyName: 'Vietnamese đồng',
        },
        WF: {
            alpha3Code: 'WLF',
            name: 'جزر والس وفوتونا',
            currencyName: 'CFP franc',
        },
        EH: {
            alpha3Code: 'ESH',
            name: 'الصحراء الغربية',
            currencyName: 'Moroccan dirham',
        },
        YE: {
            alpha3Code: 'YEM',
            name: 'اليمن',
            currencyName: 'Yemeni rial',
        },
        ZM: {
            alpha3Code: 'ZMB',
            name: 'زامبيا',
            currencyName: 'Zambian kwacha',
        },
        ZW: {
            alpha3Code: 'ZWE',
            name: 'زيمبابوي',
            currencyName: 'Botswana pula',
        },
    },
};
